import * as actionTypes from '../actions/actionTypes';
import axios from 'axios';
import qs from 'qs';
import reviewResponse from '../../assets/json/review.json';

let prod = false;

export const setFarePrice = (farePrice, flightId, flightCode, loadingType, isPolling) => {
    const parsedFarePrice = farePrice;
    return {
        type: actionTypes.SET_FARE_PRICE,
        price: parsedFarePrice,
        id: flightId,
        flightCode: flightCode,
        loadingType: loadingType,
        isPolling: isPolling
    }
}

export const setFarePriceLoading = () => {
    return {
        type: actionTypes.SET_FARE_PRICE_LOADING
    }
}

export const getFarePriceFalied = () => {
    return {
        type: actionTypes.GET_FARE_PRICE_FAILED
    }
}

export const getPollingResults = (pollingId, pollingDelay, supplierCode, flightId, flightCode, searchId, ref, dispatch, isInt) => {
    let params = [];
    params.push("supplierCode=" + supplierCode);
    params.push("pid=" + pollingId);
    const queryString = params.join("&");

    let tenant = null;
    if (isInt) { tenant = 'int2' } else { tenant = 'dom2'; }

    const promosData = {
        searchId: searchId,
        pid: pollingId,
        ref: ref,
        flightIdCSV: flightId,
        email: "",
        mobile: "",
        rphNodes: flightId.split('_')[0] + '%7Cregular'
    }

    if(!pollingDelay || parseInt(pollingDelay, 10) < 1) {
        pollingDelay = 0;
    }
    axios.post("https://secure.yatra.com/air-pay-book-service/dom2/promocode/fetch", qs.stringify(promosData))
        .then(response => {
        });
    setTimeout(function() {
        axios.get(`https://flight.yatra.com/air-service/${tenant}/price/poll?` + queryString)
            .then(response => {
                dispatch(setFarePrice(response.data, flightId, flightCode, 'secondary', true));
            });
    }, pollingDelay);
}

export const getFarePrice = (farePriceParams, flightId, flightCode) => {
    return dispatch => {
        dispatch(setFarePriceLoading());
        if(reviewResponse.pe || reviewResponse.isError) {
            console.log("Reached here");
            dispatch(getFarePriceFalied());
            return;
        }
        const lccAirlines = ['SG', '6E', 'G8', 'FZ', 'G9', 'TR', 'IX', 'AK', 'FD', 'QZ', 'D7', 'Z2', 'I5', 'XJ', 'XT', 'DJ', '2T'];
        if(!lccAirlines.includes(Object.keys(reviewResponse.data.airlineNames)[0])) {
            dispatch(getFfnData(Object.keys(reviewResponse.data.airlineNames)[0]));
        }
        dispatch(setFarePrice(reviewResponse, flightId, flightCode, 'primary', false));
        // let url = 'http://localhost:3000/farePrice/price';
        // if(prod) {
        //     url = 'https://secure.yatra.com/quicksilvercontroller/farePrice/price';
        // }
        // axios.get(
        //     url, {
        //         params: farePriceParams,
        //         headers: {'ssoToken': localStorage.getItem('ssoToken')}
        //     } 
        // )
        // .then(response => {
        //     if(reviewResponse.pe || reviewResponse.isError) {
        //         console.log("Reached here");
        //         dispatch(getFarePriceFalied());
        //         return;
        //     }
        //     const lccAirlines = ['SG', '6E', 'G8', 'FZ', 'G9', 'TR', 'IX', 'AK', 'FD', 'QZ', 'D7', 'Z2', 'I5', 'XJ', 'XT', 'DJ', '2T'];
        //     if(!lccAirlines.includes(Object.keys(reviewResponse.data.airlineNames)[0])) {
        //         dispatch(getFfnData(Object.keys(reviewResponse.data.airlineNames)[0]));
        //     }
        //     dispatch(setFarePrice(reviewResponse, flightId, flightCode, 'primary', false));
        // })
        // .catch(error => {
        //     console.log(error);
        //     dispatch(getFarePriceFalied());
        // });
    }
}

export const setFfnData = (data) => {
    return {
        type: actionTypes.SET_FFN_DATA,
        ffnData: data
    }
}

export const getFfnData = (code) => {
    return dispatch => {
        axios.get('https://secure.yatra.com/air-service/ffn-data?oacs=' + code)
        .then(response => {
            const data = JSON.parse(response.data);
            dispatch(setFfnData(data));
        })
        .catch(err => {
            console.log(err);
        })
    }
}

export const addPax = (honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected) => {
    return {
        type: actionTypes.ADD_PAX,
        title: honorific,
        firstName: firstName,
        lastName: lastName,
        paxType: paxType,
        dob: dob,
        dobRaw: dobRaw,
        number: number,
        nationality: nationality,
        selectedOption: selectedOption,
        passportExpiryDate: passportExpiryDate,
        passportExpiryDateRawValue: passportExpiryDateRawValue,
        ffnSelectedOption: ffnSelectedOption,
        frequentFlyerNumber: frequentFlyerNumber,
        isSelected: isSelected
    }
} 

export const editPax = (id) => {
    return {
        type: actionTypes.EDIT_PAX,
        id: id
    }
}

export const deletePax = (id) => {
    return {
        type: actionTypes.DELETE_PAX,
        id: id
    }
}

export const clearPax = () => {
    return {
        type: actionTypes.CLEAR_PAX
    }
}

export const setUserDetails = (val, type) => {
    return {
        type: actionTypes.SET_USER_DETAILS,
        val: val,
        valType: type
    }
}

export const togglePax = (id) => {
    return {
        type: actionTypes.TOGGLE_PAX,
        id: id
    }
}

export const toggleMealsView = (view, tripType, index) => {
    return {
        type: actionTypes.TOGGLE_MEALS_VIEW,
        val: view,
        tripType: tripType,
        index: index
    }
}

export const saveMeal = (meal, rph, uid, tripType) => {
    meal.rph = rph;
    meal.uid = uid;
    meal.trip = tripType;
    meal.isdata = true;
    meal.dispAmt = `(INR ${meal.amt})`;
    
    return {
        type: actionTypes.SAVE_MEAL,
        val: meal,
    }
}

export const saveBaggage = (baggage, rph, uid, tripType) => {
    baggage.rph = rph;
    baggage.uid = uid;
    baggage.trip = tripType;
    baggage.isdata = true;
    baggage.dispAmt = `(INR ${baggage.amt})`;
    return {
        type: actionTypes.SAVE_BAGGAGE,
        val: baggage
    }
}

export const saveSeat = (seat) => {
    return {
        type: actionTypes.SAVE_SEAT,
        val: seat
    }
}

export const selectMeal = (id, flow, isUpdate) => {
    return {
        type: actionTypes.SELECT_MEAL,
        val: id,
        flow: flow,
        isUpdate: isUpdate
    }
}

export const selectBaggageSSR = (id, flow, isUpdate) => {
    return {
        type: actionTypes.SELECT_BAGGAGE,
        val: id,
        flow: flow,
        isUpdate: isUpdate
    }
}

export const deselectMeal = (id, flow) => {
    return {
        type: actionTypes.DESELECT_MEAL,
        val: id,
        flow: flow
    }
}

export const deselectBaggage = (id, flow) => {
    return {
        type: actionTypes.DESELECT_BAGGAGE,
        val: id,
        flow: flow
    }
}

export const toggleBaggageView = (view, tripType, index) => {
    return {
        type: actionTypes.TOGGLE_BAGGAGE_VIEW,
        val: view,
        tripType: tripType,
        index: index
    }
}

export const toggleSeatsView = (view, tripType, index) => {
    return {
        type: actionTypes.TOGGLE_SEATS_VIEW,
        val: view,
        tripType: tripType,
        index: index       
    }
}

export const selectSeat = (id, flow) => {
    return {
        type: actionTypes.SELECT_SEAT,
        val: id,
        flow: flow
    }
}

export const deselectSeat = (id, flow) => {
    return {
        type: actionTypes.DESELECT_SEAT,
        val: id,
        flow: flow
    }
}

export const changeMealsFlow = (flow) => {
    return {
        type: actionTypes.CHANGE_MEALS_FLOW,
        val: flow
    }
}

export const resetFarePrice = () => {
    return {
        type: actionTypes.RESET_FARE_PRICE
    }
}

export const closePax = () => {
    return {
        type: actionTypes.CLOSE_PAX
    }
}

export const showPax = () => {
    return {
        type: actionTypes.SHOW_PAX
    }
}

export const addAddon = (addon) => {
    return {
        type: actionTypes.ADD_ADDON,
        addon: addon
    }
}

export const removeAddon = (label, amount, legIndex, leg) => {
    return {
        type: actionTypes.REMOVE_ADDON,
        label: label,
        amount: amount,
        legIndex: legIndex,
        leg: leg
    }
}

export const addInsurance = () => {
    return {
        type: actionTypes.ADD_INSURANCE
    }
}

export const addAssure = () => {
    return {
        type: actionTypes.ADD_ASSURE
    }
}

export const removeAddonFromFarePrice = (label) => {
    return {
        type: actionTypes.REMOVE_ADDON_FROM_FARE_PRICE,
        label: label
    }
}

export const setGstDetails = (name, value) => {
    return {
        type: actionTypes.SET_GST_DETAILS,
        name: name,
        value: value
    }
}

export const clearGstDetails = () => {
    return {
        type: actionTypes.CLEAR_GST_DETAILS
    }
}

export const addGst = () => {
    return {
        type: actionTypes.ADD_GST
    }
}

export const addOnlyPax = (honorific, firstName, lastName, paxType, dob, dobRaw, number, nationality, selectedOption, passportExpiryDate, passportExpiryDateRawValue, ffnSelectedOption, frequentFlyerNumber, isSelected) => {
    return {
        type: actionTypes.ADD_ONLY_PAX,
        title: honorific,
        firstName: firstName,
        lastName: lastName,
        paxType: paxType,
        dob: dob,
        dobRaw: dobRaw,
        number: number,
        nationality: nationality,
        selectedOption: selectedOption,
        passportExpiryDate: passportExpiryDate,
        passportExpiryDateRawValue: passportExpiryDateRawValue,
        ffnSelectedOption: ffnSelectedOption,
        frequentFlyerNumber: frequentFlyerNumber,
        isSelected: isSelected
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/farePrice.js